import moment from 'moment';
import * as yup from 'yup'

export const SCHEMA = yup.object().shape({
  dataFim: yup
    .date()
    .required('Informe uma data.')
    .typeError('Digite uma data válida.')
    .min(yup.ref('dataInicio'), 'Data fim deve ser maior que data inicial')
    .nullable(),
  dataInicio: yup
    .date()
    .required('Informe uma data.')
    .typeError('Digite uma data válida.')
    .max(yup.ref('dataFim'), 'Data inicial deve ser menor que data fim')
    .nullable(),
  competenciaFim: yup
    .date()
    .typeError('Digite uma competencia válida.')
    .min(yup.ref('competenciaInicio'), 'Competencia final deve ser maior que data inicial')
    .nullable(),
  competenciaInicio: yup
    .date()
    .typeError('Digite uma competencia válida.')
    .max(yup.ref('competenciaFim'), 'Competencia inicial deve ser menor que data fim')
    .nullable()
})

